import api from "./api";


export const getAllHospitals = async () => {
  const { data } = await api.get("/api/hospital");
  return data.data;
};

export const getHospitalById = async (id: string) => {
  const res = await api.get(`/api/hospital/${id}`);
  console.log(res.data.data,"res.data.data");
  return res.data.data;
};


type HospitalStatus = "PENDING" | "ACTIVE" | "SUSPENDED";

interface UpdateHospitalStatusPayload {
  status: HospitalStatus;
}

export const updateHospitalStatus = async (hospitalId: string,payload: UpdateHospitalStatusPayload) => {
  const res = await api.patch(`/api/hospital/${hospitalId}/status`,payload);
  return res.data;
};

